import { RadioGroup, type RadioGroupOption } from '@/components/common/RadioGroup'
import type { WebinarRoomType } from '@/types/webinarRoom'
import { BIGMARKER_ROOM, ORBITALX_ROOM } from '@/utils/onlineEventMode'

const ROOM_OPTIONS: RadioGroupOption[] = [
    {
        value: ORBITALX_ROOM,
        label: 'OrbitalX room',
        description: 'The uploaded recording streams at the scheduled time, in a room in the client’s brand. Chat, Q&A and polls run there.',
    },
    {
        value: BIGMARKER_ROOM,
        label: 'BigMarker',
        description: 'Created in BigMarker on the chosen channel when you sign off. Chat, polls and replay run in BigMarker.',
    },
]

/** Under Mode for an OrbitalX-room web: the mode is what decides the replay. */
export const ROOM_MODE_HELP = 'Hybrid: the replay is up as soon as the session ends. Upcoming: no replay from us, for clients who host it themselves.'

interface RoomChoiceFieldProps {
    name: string
    value: WebinarRoomType
    onChange: (room: WebinarRoomType) => void
    /** One card per row in a narrow panel. */
    cardColumns?: 1 | 2
    /** Said after "Fixed when you sign off.", for what switching the room leaves behind. */
    note?: string
    /** The room is fixed: the web has its conference id from a sign-off or an import. */
    disabled?: boolean
}

/**
 * The room a web runs in, OrbitalX room or BigMarker (ORB-1086). Shared by the New web panel and the
 * Event details card, so both offer the same two rooms in the same words.
 */
export function RoomChoiceField({ name, value, onChange, cardColumns, note, disabled }: RoomChoiceFieldProps) {
    return (
        <RadioGroup
            name={name}
            label="Room"
            required
            labelSize="xs"
            layout="cards"
            cardColumns={cardColumns}
            options={disabled ? ROOM_OPTIONS.map(option => ({ ...option, disabled: true })) : ROOM_OPTIONS}
            value={value}
            onChange={room => onChange(room as WebinarRoomType)}
            helperText={note ? `Fixed when you sign off. ${note}` : 'Fixed when you sign off.'}
        />
    )
}
